import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import './i18n';
import './polyfill';
import './index.css';
import './services/axiosService';

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);
